import { render, staticRenderFns } from "./Goals.vue?vue&type=template&id=0bd4a564&scoped=true"
import script from "./Goals.vue?vue&type=script&lang=ts"
export * from "./Goals.vue?vue&type=script&lang=ts"
import style0 from "./Goals.vue?vue&type=style&index=0&id=0bd4a564&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bd4a564",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0bd4a564')) {
      api.createRecord('0bd4a564', component.options)
    } else {
      api.reload('0bd4a564', component.options)
    }
    module.hot.accept("./Goals.vue?vue&type=template&id=0bd4a564&scoped=true", function () {
      api.rerender('0bd4a564', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/companyProjects/ClientTabsComponents/Steps/CarePlanSteps/Goals.vue"
export default component.exports